import React from 'react'
import clsx from 'clsx'
import { Clear } from '@mui/icons-material'

import Tag2Icon from '../../../../../icons/Tag2Icon'

import useStyles from './styles'

const TagV2 = ({ tag, onDelete, disabled }) => {
  const classes = useStyles()

  const handleClickDelete = React.useCallback(
    e => {
      e.stopPropagation()
      onDelete(tag)
    },
    [onDelete, tag]
  )

  return (
    <div data-testid={`item-tag-${tag}`} className={classes.root}>
      <Tag2Icon
        fill='#8F8F8F'
        className={clsx(classes.icon, classes.tagIcon)}
      />

      <label>{tag}</label>

      {!disabled && (
        <Clear
          onClick={handleClickDelete}
          fill='#8F8F8F'
          className={clsx(classes.removeTagIcon, classes.muiIcon)}
        />
      )}
    </div>
  )
}

export default TagV2
